import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/industrias/medical-devices/md-cro-cardiología")({
  head: () => buildRouteHead("/es/industrias/medical-devices/md-cro-cardiología", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/servicios/clinical-solutions", replace: true });
  },
});
